import { render } from "./BannerShow.vue?vue&type=template&id=04561668"
import script from "./BannerShow.vue?vue&type=script&lang=js"
export * from "./BannerShow.vue?vue&type=script&lang=js"

import "./BannerShow.vue?vue&type=style&index=0&id=04561668&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__